import { useMemo } from 'react';
import { maybe } from '@passionware/monads';
import {
  appRouting,
  type EnterpriseWorkspaceRoutes
} from 'v5/core/routing/appRouting';
import { myRouting } from 'v5/features/core/routing';
import type { WithServices } from 'v5/platform/ts/services';
import type { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { adaptLegacyWorkspaceRoutingForLinks } from './adaptLegacyWorkspaceRoutingForLinks';
import { appScopeUtils } from './appScope.types';

/** Routes in the workspace `workspaceSlug`; without one, the legacy organization routes. */
export function workspaceRoutesFor(
  organizationId: string,
  workspaceSlug: string | undefined
): EnterpriseWorkspaceRoutes {
  return workspaceSlug
    ? appRouting.org(organizationId).workspace(workspaceSlug)
    : adaptLegacyWorkspaceRoutingForLinks(
        myRouting.forWorkspace(organizationId)
      );
}

/**
 * Routes in the workspace the user browses — a team page's workspace too, and
 * the opener's scope inside a modal or drawer. Organization scope gives the
 * legacy organization routes.
 */
export function useBrowsingWorkspaceRoutes(
  services: WithServices<[WithAppScopeService]>['services']
): EnterpriseWorkspaceRoutes {
  const scope = services.appScopeService.useSlugAppScope();
  const workspaceSlug = maybe.getOrUndefined(
    appScopeUtils.getWorkspaceSlug(scope)
  );
  return useMemo(
    () => workspaceRoutesFor(scope.organizationId, workspaceSlug),
    [scope.organizationId, workspaceSlug]
  );
}
